import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../theme/reset.css'

import { AtomProvider } from '@atom-web/core'
import { ThemeProvider as AtomThemeProvider } from '@pyt/core/native'
import * as theme from '@pyt/ui/theme/veho'
import { useAmp } from 'next/amp'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useEffect, useReducer, useState } from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { ThemeProvider } from 'styled-components'

import { AppConfig } from '../app-config'
import AnalyticsWrapper from '../components/AnalyticsWrapper'
import GlobalStyle from '../components/GlobalStyles'
import AppContext from '../store/AppContext'
import AppState from '../store/AppState'
import AtomTheme from '../theme/config'
import IxigoAtomTheme from '../theme/ixigo-config'
import vehoTheme from '../theme/veho'
import GTMWrapper from '../utils/analytics/gtm'
import cleanPath from '../utils/cleanPath'
import {
	fetchLocaleFromUrl,
	fetchLocaleInfoFromApi,
} from '../utils/locale-helpers/fetch-locale-info'
import get from '../utils/lodashUtils/get'

// Dynamic imports
const CountryConfirmationDialog = dynamic(() =>
	import('../components/CountryConfirmationDialog'),
)

import reduxStore from '../redux/store'
import GoogleAnalytics from '../utils/analytics/gtag'
import isIxigoPartnersSite from '../utils/isIxigoPartnersSite'

const LOCALE_MAP = {
	'': 'India',
	in: 'India',
	us: 'United States',
	ae: 'UAE',
}

function MyApp({ Component, pageProps }) {
	const isAmp = useAmp()
	const router = useRouter()
	const [locale, setLocale] = useState('')
	const [localeFromIP, setLocaleFromIP] = useState('')
	const [countryPopupMeta, setCountryPopupMeta] = useState({
		shown: false,
		show: false,
		userCountry: '',
		currentCountry: '',
	})

	useEffect(() => {
		const onClose = locale => {
			localStorage.setItem('preferred_locale', locale === 'in' ? '' : locale)

			if (pageProps.errorCode) {
				location.href = `/${locale}`
			}

			setCountryPopupMeta({ show: false })
		}

		const onPrimaryButtonClick = localeFromIP => {
			const userPreferredLocale = localStorage.getItem('preferred_locale') || ''
			const targetLocale = userPreferredLocale || localeFromIP

			console.log({
				targetLocale,
				userPreferredLocale,
				localeFromIP,
			})

			const pageSupportedLocales = get(
				pageProps,
				'packages.campaignDetails.locales',
				[],
			)
			console.log({ pageSupportedLocales })

			localStorage.setItem('preferred_locale', targetLocale)

			if (targetLocale === '' || pageSupportedLocales?.includes(targetLocale)) {
				const pathWithoutLocale = cleanPath(router.asPath)

				location.href = `${
					targetLocale.length > 0 ? `/${targetLocale}` : ''
				}/${pathWithoutLocale}`
			} else {
				location.href = `/${targetLocale}`
			}
		}

		// Fetch locale information
		async function fetchLocaleData() {
			// Locale information from URL if any
			const routeLocale = router.locale
				? router.locale
				: await fetchLocaleFromUrl({ url: router.asPath })
			fetchLocaleInfoFromApi()
				.then(res => {
					const ipLocale =
						res?.data?.locale === AppConfig.defaultLocale
							? ''
							: res?.data?.locale
					const defaultLocale =
						routeLocale === AppConfig.defaultLocale ? '' : routeLocale

					setLocaleFromIP(ipLocale || '')
					setLocale(defaultLocale || '')

					// Moving conditions here to run once
					const userPreferredLocale =
						localStorage.getItem('preferred_locale') || ''

					console.log({
						userPreferredLocale,
						localeFromIP: ipLocale,
						routeLocale,
						defaultLocale,
					})
					console.log(
						'firstCond locale: ',
						userPreferredLocale.length > 0 &&
							userPreferredLocale !== defaultLocale,
					)

					if (
						!countryPopupMeta.shown &&
						['', 'ae', 'us'].includes(ipLocale) &&
						((userPreferredLocale.length > 0 &&
							userPreferredLocale !== defaultLocale) ||
							(userPreferredLocale.length === 0 && defaultLocale !== ipLocale))
					) {
						const targetLocale = userPreferredLocale || ipLocale
						setCountryPopupMeta({
							shown: true,
							show: true,
							userCountry: LOCALE_MAP[targetLocale],
							currentCountry: LOCALE_MAP[defaultLocale],
							onClickPrimary: () => onPrimaryButtonClick(ipLocale || ''),
							onClickSecondary: () => onClose(defaultLocale || ''),
							onClose: () => onClose(defaultLocale || ''),
						})
					}
				})
				.catch(err => {
					console.error(err)
					setLocale('')
				})
		}

		if (process.env.NODE_ENV === 'production') {
			fetchLocaleData()
		}
	}, [countryPopupMeta, pageProps, router])

	return (
		<div>
			<div id="modal-root" />
			<div id="modal-portal-container" />
			<GlobalStyle />
			{isAmp ? null : <GTMWrapper />}
			<GoogleAnalytics />
			<AtomProvider theme={isIxigoPartnersSite() ? IxigoAtomTheme : AtomTheme}>
				<AtomThemeProvider theme={vehoTheme}>
					<ThemeProvider theme={theme}>
						<ReduxProvider store={reduxStore}>
							<AppContext.Provider
								value={useReducer(AppState, { localeFromIP, locale })}
							>
								<AnalyticsWrapper locale={localeFromIP}>
									<Component {...pageProps} />
									{isAmp ? null : (
										<CountryConfirmationDialog {...countryPopupMeta} />
									)}
								</AnalyticsWrapper>
							</AppContext.Provider>
						</ReduxProvider>
					</ThemeProvider>
				</AtomThemeProvider>
			</AtomProvider>
		</div>
	)
}

export function reportWebVitals(metric) {
	console.log({ metric })
}

export default MyApp
